var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0773 9.8123H10.4108L10.1746 9.58449C11.0014 8.62263 11.4992 7.3739 11.4992 6.01548C11.4992 2.98646 9.04401 0.531189 6.0151 0.531189C2.98619 0.531189 0.531006 2.98646 0.531006 6.01548C0.531006 9.0445 2.98619 11.4998 6.0151 11.4998C7.37347 11.4998 8.62215 11.002 9.58398 10.1751L9.81178 10.4114V11.0779L14.0303 15.2882L15.2874 14.031L11.0773 9.8123ZM6.0151 9.8123C3.91427 9.8123 2.21842 8.11639 2.21842 6.01548C2.21842 3.91458 3.91427 2.21866 6.0151 2.21866C8.11593 2.21866 9.81178 3.91458 9.81178 6.01548C9.81178 8.11639 8.11593 9.8123 6.0151 9.8123Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.188c744c.svg";
export { ForwardRef as ReactComponent };